import type { components } from '@fluencelabs/vodopad-admin-api'
import { useCustom } from '@refinedev/core'

import { VODOPAD_ENDPOINT } from '@/constants/constants'

type ClusterResourcesDto = components['schemas']['ClusterResourcesDto']

export function useClusterResources(clusterId: string | undefined) {
  const query = useCustom<ClusterResourcesDto>({
    url: `${VODOPAD_ENDPOINT}/v1/clusters/${clusterId}/resources`,
    method: 'get',
    queryOptions: {
      enabled: Boolean(clusterId),
      staleTime: 10 * 60 * 1000,
    },
  })

  const data = query.query.data?.data as ClusterResourcesDto | undefined

  return {
    configurations: data?.availableConfigurations ?? [],
    availableStorage: data?.availableStorage ?? {},
    availablePublicIps: data?.availablePublicIps ?? {},
    loading: query.query.isLoading,
  }
}
